import { cn } from "@/lib/utils";

type AnimatedMusicBarProps = {
  active?: boolean;
  className?: string;
};

export function AnimatedMusicBar({ active, className }: AnimatedMusicBarProps) {
  if (active === false) {
    return (
      <div className={cn("bg-transparent w-4 h-4", className)}>
        <div className="flex items-center justify-center space-x-[2px] w-full h-full">
          <div className="w-[2px] h-[12px] bg-white rounded" />
          <div className="w-[2px] h-[8px] bg-white rounded" />
          <div className="w-[2px] h-[4px] bg-white rounded" />
          <div className="w-[2px] h-[4px] bg-white rounded" />
        </div>
      </div>
    );
  }
  return (
    <div className={cn("bg-transparent w-4 h-4", className)}>
      <div className="flex items-center justify-center space-x-[2px] w-full h-full">
        <div className="w-[2px] bg-white rounded animate-bar3" />
        <div className="w-[2px] bg-white rounded animate-bar2" />
        <div className="w-[2px] bg-white rounded animate-bar1" />
        <div className="w-[2px] bg-white rounded animate-bar4" />
      </div>
    </div>
  );
}
